module.exports = __webpack_public_path__ + "img/BuE DS Deinstallation.7282bf39.png";